import {
    userItemRequest,
    usersPageListRequest
} from "../../../actions/user-actions"
import UserListItem from "../../common/UserListItem"
import UserListItemShadow from "../../common/UserListItemShadow" 
import buildListContainer from "../../common/build-list-container"

export default buildListContainer(
    UserListItem,
    UserListItemShadow,
    usersPageListRequest,
    userItemRequest,
    "users"
)
